import React, { type FC } from "react"
import Hero from "@components/Hero"
import parseContentImages, { ParseContentImagesProps } from "@utils/parseContentImages"

// eslint-disable-next-line react/require-default-props
const StrapiHero: FC<Queries.StrapiComponentSectionsHero & { isFrontpage?: boolean }> = ({
    content,
    content_images: contentImages,
    isFrontpage
}) => {
    return <Hero
        content={parseContentImages(
            content,
            contentImages as unknown as ParseContentImagesProps[]
        )}
        isFrontpage={isFrontpage}
    />
}

export default StrapiHero
